import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { IProfile } from 'interfaces/profile.interface';
import { useMain } from 'contexts/main.context';
import Input from 'components/input/input.component';
import Button from 'components/button/button.component';
import Loader from 'components/loader/loader.component';
import { markInvalidFields } from 'utils/form.utils';
import { updateQoldauToken } from 'requests/dashboard.request';
import TelegramCard from './telegram-card.component';
import './profile.style.scss';

const Profile = () => {
  const { t } = useTranslation();
  const { applicantData } = useMain();
  const [loading, setLoading] = useState(false);
  const formik: FormikProps<IProfile> = useFormik({
    initialValues: {
      applicantName: '',
      applicantBin: '',
      qoldauToken: '',
    },
    validationSchema: Yup.object().shape({
      qoldauToken: Yup.string().required(t('validation.required') as string),
    }),
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  useEffect(() => {
    void formik.setFieldValue('applicantName', applicantData.applicantName ?? '');
    void formik.setFieldValue('applicantBin', applicantData.applicantBin ?? '');
    void formik.setFieldValue('qoldauToken', applicantData.qoldauToken ?? '');
  }, [applicantData]);

  const handleChange = ({ target: { name, value } }: React.ChangeEvent<HTMLInputElement>) => {
    void formik.setFieldValue(name, value, true);
  };

  const handleSave = () => {
    formik.validateForm().then(() => {
      if (Object.keys(formik.errors).length > 0) {
        markInvalidFields(formik, 'auth');
      } else {
        const { qoldauToken } = formik.values;
        updateQoldauToken(qoldauToken)
          .then(() => toast.success(t('success.tokenSaved')))
          .catch(() => toast.error(t('errors.tokenSave')))
          .finally(() => setLoading(false));
      }
    });
  };

  return (
    <Loader loading={loading}>
      <div className="wrapper">
        <h1 className="title">{t('navigation.profile')}</h1>
        <div className="profile__form">
          <Input
            formik={formik}
            name="applicantName"
            value={formik.values.applicantName}
            label={t('auth.username')}
            onChange={handleChange}
            disabled={true}
          />
          <Input
            formik={formik}
            name="applicantBin"
            value={formik.values.applicantBin}
            label={t('auth.iinBin')}
            onChange={handleChange}
            disabled={true}
          />
          <Input
            formik={formik}
            name="qoldauToken"
            value={formik.values.qoldauToken}
            label={t('auth.qoldauToken')}
            onChange={handleChange}
          />
          <div>
            <Button onClick={handleSave} primary>
              {t('common.save')}
            </Button>
          </div>
        </div>

        <TelegramCard />
      </div>
    </Loader>
  );
};

export default Profile;
